import React from 'react';
import { renderRoutes } from 'react-router-config';

/**
 *
 * @param props
 * @returns {null}
 * @constructor
 */
const Player = ( props ) => {
    return renderRoutes( props.route.routes, { route: props.route.routes } );
};

export default Player;